
namespace RioERP.Reports {
    export class OrderSaleReportColumns {
        static columnsKey = 'Reports.OrderSaleReport';
    }
}